<template>
  <FormContainer without-divider>
    <template #title>Établissement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_1"
          :model-value="model?.employeur?.etablissement?.denomination"
          label="Nom et Prénom ou dénomination"
          class="col-22 col-sm-36"
          :required="meta.employeur?.etablissement?.denomination?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.denomination?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_2"
          :model-value="model?.employeur?.etablissement?.siret?.valeur"
          label="SIRET"
          class="col-14 col-sm-36"
          :required="meta.employeur?.etablissement?.siret?.valeur?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.siret?.valeur?.$messageErreurDirty!"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_8"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-4 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.naf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.naf?.code?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_9"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-4 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.idcc?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.idcc?.code?.$messageErreurDirty!"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'

  const store = useDemandeAFStore()
  const { meta, model } = storeToRefs(store)
</script>
